<template>
	<el-drawer title="配置详情" :visible.sync="dialogVisible" :modal-append-to-body="false" size="1000px" direction="rtl"
		:wrapperClosable="false" class="customer-drawer-common edit-setting">
		<div v-loading="loadingDialog">
			<ul class="edit-setting__header">
				<li class="scene">场景</li>
				<li class="name">功能</li>
				<li class="desc">描述</li>
				<li class="operate">操作</li>
			</ul>
			<div class="edit-setting__list">
				<div class="edit-setting__item" v-for="(item,index) in filterData" :key="index">
					<ul class="parent">
						<li class="scene">{{item.scene}}</li>
						<li class="name">{{item.name}}</li>
						<li class="desc">
							<span v-if="item.key && item.operate != 'radio'">
								{{item.label}}
								<el-popover width="300" trigger="hover"
									:content="item.descrption">
									<i slot="reference" class="el-icon-warning" style="margin: 0 5px;" />
								</el-popover>
								<el-input-number placeholder="请输入数字" type="number" :min="1" :precision="1"
									v-model="listQuery[item.key]" size="mini" /> 分钟

							</span>
							<span v-else v-html="item.descrption"></span>
						</li>
						<li class="operate">
							<el-switch v-model="item.enabled" v-show="item.operate == 'swicth'" @change="onSwitchChange(item)">
							</el-switch>
							<el-radio-group v-model="satisfaction[item.key]" v-show="item.operate == 'radio'">
								<el-radio label="1">自动发送</el-radio>
								<el-radio label="0" disabled>手动发送</el-radio>
							</el-radio-group>
						</li>
					</ul>
					 <transition name="el-zoom-in-top">
					    <div v-show="item.enabled && item.children" class="sub-transition-box">
							<ul class="parent" v-for="(_item,_index) in item.children" :key="_index">
								<li class="scene"></li>
								<li class="name">{{_item.name}}</li>
								<li class="desc">
									<el-popover width="300" trigger="hover"
										:content="_item.descrption">
										<i slot="reference" class="el-icon-warning"  v-show="_item.descrption"/>
									</el-popover>
									<span  v-if="_item.descrption" style="margin: 0 5px;">
										<el-input-number  placeholder="请输入数字" type="number" :min="1" :precision="1"
										v-model="listQuery[_item.key]" size="mini"/> 分钟
									</span>
									<el-input :placeholder="'请输入'+ _item.name"
											v-model="listQuery[_item.key]" size="mini" v-else/>
								</li>
								<li class="operate"></li>
							</ul>
						</div>
					</transition>
				</div>
			</div>
			<div class="footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="onSave" :loading="loading">确 定</el-button>
			</div>
		</div>
	</el-drawer>
</template>

<script>
	import { chatSystemLists } from '../data.js';
	export default {
		data() {
			return {
				dialogVisible: false,
				loading: false,
				brand: '',
				skillGroup: '',
				data: [],
				loadingDialog: false,
				listQuery: {
					autoCloseSessionTimeOfAgent: '', //CSR发送消息后客人未响应自动关闭会话的时间
					autoCloseLeaveMsgTime: '', //客人发消息后一段时间没有交互自动关闭留言的时间
					autoCloseSessionTimeOfCustomer: '', //客人发送消息后CSR未响应自动关闭会话的时间
					scorePageUrl: '', //满意度评分页面的地址
					autoCloseUnconfirmJoinQueueTime: '', //客人确认加入队列等待时间
					autoCloseUnconfirmJoinSessionTime: '', //客人确认加入会话等待时间
				},
				satisfaction:{
					autoSendScorePage:'1'
				},
				apiData:[]
			}
		},
		computed:{
			filterData(){
				return this.data.filter(el => !el.hidden)
			}
		},
		methods: {
			onSwitchChange(row){
				if(row.muta_index){
					if(this.data[row.muta_index].enabled) {
						this.data[row.muta_index].enabled = !row.enabled
					}
					
				}
			},
			onSave() {
				let params = {
					autoSendScorePage: this.satisfaction.autoSendScorePage,
					brand: this.brand,
					skillGroup: this.skillGroup,
					chatBaseConfigDTO: this.listQuery,
					pageSwitchList: this.data.filter(el => !el.hidden)
				}
				this.loading = true
				this.$api.saveSystemSatisfaction(this.skillGroup, params).then(res => {
					if (res.errcode == 0) {
						this.loading = false;
						this.dialogVisible = false
						this.$message.success('保存成功');
						this.$emit('getList')
					}
				})
			},
			openSetting(row) {
				this.brand = row.childBrand ? row.childBrand : row.brand;
				this.skillGroup = row.skillId;
				this.dialogVisible = true;
				this.getData(row.skillId)
			},
			parseData(data){
				let results = JSON.parse(JSON.stringify(chatSystemLists));
				for(let item of results) {
					for(let _item of data) {
						if(item.id == _item.id){
							item.enabled = _item.enabled
						}
					}
				}
				return results;
			},
			getData(skillGroup) {
				this.loadingDialog = true;
				this.$api.getSystemSatisfaction(skillGroup).then(res => {
					if (res.errcode == 0) {
						this.loadingDialog = false;
						this.data = this.parseData(res.data.pageSwitchList);
						this.apiData = res.data.pageSwitchList;
						this.satisfaction.autoSendScorePage = res.data.autoSendScorePage
						this.listQuery = Object.assign({}, res.data.chatBaseConfigDTO);
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.edit-setting {
		$scene_width: 150px;
		$name_width: 190px;
		font-size: 14px;

		.el-drawer__body {
			height: calc(100vh - 100px);
			overflow-y: scroll;
		}

		&__header {
			width: 100%;
			display: flex;
			justify-content: space-between;
			background-color: #f5f7fa;
			padding: 0 10px;

			li {
				list-style: none;
				height: 50px;
				line-height: 50px;
				font-weight: bold;

				&.scene {
					width: $scene_width;
				}

				&.name,
				&.operate {
					width: $name_width;
				}

				&.operate {
					padding-left: 50px;
				}

				&.desc {
					width: calc(100% - #{$name_width + $scene_width + $name_width});
				}

			}
		}

		&__item {
			width: 100%;
			padding: 0 10px;
			color: #606266;

			&:not(:nth-of-type(1)) {
				border-top: 1px solid #ebeef5;
			}

			cursor: pointer;

			.parent {
				display: flex;
				justify-content: space-between;
			}
			.sub-transition-box {
				width: 100%;
				border-top: 1px solid #ebeef5;
				li {
					&.name {
						padding-left: 14px;
					}
				}
			}

			li {
				list-style: none;
				min-height: 50px;
				display: flex;
				align-items: center;

				&.scene {
					width: $scene_width;
				}

				&.name,
				&.operate {
					width: $name_width;
				}

				&.desc {
					width: calc(100% - #{$name_width + $scene_width + $name_width});
					line-height: 22px;
				}

				&.scene {
					color: #337EFF;
				}

				&.operate {
					padding-left: 50px;
				}

			}
		}
		.footer {
			margin: 20px 0;
		}
	}
</style>
